'use strict';

function getOwnPropertyDescriptors(obj) {
  var descriptors = {};

  Object.getOwnPropertyNames(obj).forEach(function forEachOwnProp(prop) {
    descriptors[prop] = Object.getOwnPropertyDescriptor(obj, prop);
  });

  return descriptors;
}
exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/arborist/lib/helpers/object_helpers.js
// module id = 712
// module chunks = 0